import React from "react";
import theme from "theme";
import {Theme, Image, Box, Text, Button, Section} from "@quarkly/widgets";
import {Helmet} from "react-helmet";
import {GlobalQuarklyPageStyles} from "global-page-styles";
import {RawHtml, Override} from "@quarkly/components";
import * as Components from "components";
// import {useMediaQuery} from 'react-responsive';

const toolkitImg = "/assets/toolkit_en.svg";
const heroMockupImg = "/assets/cdzv_hero_mockup.png";

const blackFriday = () => {
    return null;
    // return <Image
    //     style={{
    //         padding: '50px 0px 0px 0px',
    //     }}
    //     src="https://cdzv.com/strategy_img/Image_2024-11-25_22-38-13.jpg"
    //     width={"100%"}
    //     preview={false}
    // />
}

const UdemyBanner = () => {
    return (
        <div style={{
            background: 'linear-gradient(135deg, #1e0b36 0%, #0c0217 100%)',
            border: '1px solid rgba(138, 43, 226, 0.25)',
            borderRadius: '24px',
            padding: '40px 30px',
            maxWidth: '1100px',
            margin: '60px auto 20px auto',
            color: '#ffffff',
            fontFamily: 'Inter, sans-serif',
            boxShadow: '0 20px 50px rgba(138, 43, 226, 0.15), 0 10px 30px rgba(0,0,0,0.4)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '30px',
            position: 'relative',
            overflow: 'hidden'
        }}>
            <style dangerouslySetInnerHTML={{__html: `
                .udemy-btn {
                    background: linear-gradient(135deg, #ec5252 0%, #d43b3b 100%);
                    color: #ffffff !important;
                    font-weight: 700;
                    font-size: 16px;
                    padding: 14px 28px;
                    border-radius: 12px;
                    border: none;
                    cursor: pointer;
                    text-decoration: none;
                    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
                    box-shadow: 0 6px 20px rgba(236, 82, 82, 0.35);
                    display: inline-block;
                }
                .udemy-btn:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 12px 25px rgba(236, 82, 82, 0.55);
                }
                @media (max-width: 768px) {
                    .udemy-content {
                        text-align: center;
                        width: 100%;
                    }
                    .udemy-action {
                        justify-content: center;
                        width: 100%;
                    }
                }
            `}} />
            <div className="udemy-content" style={{ flex: '1 1 600px' }}>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center', marginBottom: '15px' }}>
                    <span style={{
                        background: 'rgba(236, 82, 82, 0.1)',
                        color: '#ec5252',
                        padding: '6px 14px',
                        borderRadius: '20px',
                        fontSize: '12px',
                        fontWeight: '700',
                        textTransform: 'uppercase',
                        letterSpacing: '1px',
                        display: 'inline-flex',
                        alignItems: 'center'
                    }}>Udemy Crash Course</span>
                    
                    <span style={{
                        background: 'rgba(0, 255, 136, 0.08)',
                        color: '#00FF88',
                        padding: '6px 14px',
                        borderRadius: '20px',
                        fontSize: '12px',
                        fontWeight: '700',
                        textTransform: 'uppercase',
                        letterSpacing: '1.2px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        border: '1px solid rgba(0, 255, 136, 0.2)'
                    }}>
                        <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#00FF88', display: 'inline-block', boxShadow: '0 0 8px #00FF88' }}></span>
                        Udemy Quality Audit Passed
                    </span>
                </div>
                <h3 style={{ fontSize: '28px', fontWeight: '800', margin: '0 0 12px 0', letterSpacing: '-0.5px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
                        <path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" fill="url(#goldGradEn)" stroke="#FFD700" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M9 11L11 13L15 9" stroke="#00FF88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <defs>
                            <linearGradient id="goldGradEn" x1="4" y1="2" x2="20" y2="22" gradientUnits="userSpaceOnUse">
                                <stop offset="0%" stopColor="#7b2fce"/>
                                <stop offset="100%" stopColor="#5a1da8"/>
                            </linearGradient>
                        </defs>
                    </svg>
                    Master Algo-Trading with a Verified Course!
                </h3>
                <p style={{ fontSize: '15.5px', color: 'rgba(255,255,255,0.8)', margin: 0, lineHeight: '1.6' }}>
                    Our instructional content has successfully passed strict independent quality audits prior to publication. Udemy is a premier global learning platform that only lists authorized, rigorously vetted educational material. Publishing our course on Udemy serves as an official seal of compliance with superior pedagogical and technical standards.
                </p>
            </div>
            <div className="udemy-action" style={{ display: 'flex', alignItems: 'center' }}>
                <a 
                    href="https://www.udemy.com/course/algo-trading-zero-code/?referralCode=8665AB260D9F7506BDCE" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="udemy-btn"
                >
                    Start Crash Course
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{marginLeft: '6px'}}><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                </a>
            </div>
        </div>
    );
};

export default (() => {

    // const isMobile = useMediaQuery({maxWidth: 450});
    // const isMobileHR = useMediaQuery({maxWidth: 767});
    // const isTablet = useMediaQuery({minWidth: 768, maxWidth: 819});
    // const isTabletHR = useMediaQuery({minWidth: 820, maxWidth: 1280});
    // const isDesktop = useMediaQuery({minWidth: 1281});

    return <Theme theme={theme}>
        <GlobalQuarklyPageStyles pageUrl={"index"}/>
        <Helmet>
            <title>CDZV | Build, Test and Automate trading strategies without programming.</title>
            <meta name="keywords"
                  content="Code Zero Visual Trading, CDZV, TradingView, indicator, strategy, backtesting, algo-trading, trading, forex, stock, crypto, cryptocurrency, profit, algorithmic trading, automated trading, trading tools, trading platform, no-code trading, visual trading, trading automation, create strategy, build strategy, test strategy, automate strategy, webhooks"/>
            <meta name="description"
                  content="Code Zero Visual Trading (CDZV) fot TradingVieew. Build, test and automate your trading strategy in minutes without programming. Quickly evaluate your ideas and turn them into profitable solutions with our tools. Build strategies in minutes without coding skills."/>
            <meta property="og:description"
                  content="Code Zero Visual Trading (CDZV) fot TradingVieew. Build, test and automate your trading strategy in minutes without programming. Quickly evaluate your ideas and turn them into profitable solutions with our tools. Build strategies in minutes without coding skills."/>
            <meta name="author" content="Code Zero Visual Trading"/>
            <link rel="canonical" href="https://cdzv.com/"/>
            <link rel="shortcut icon" href="favicon.ico"/>
        </Helmet>
        <Components.CdzvMenu/>
        {blackFriday()}
        <Section padding="120px 0 60px 0" quarkly-title="CDZVHero" background="transparent" id="home">
            <style>{`
                .hero-mockup-wrap {
                    width: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .hero-mockup-wrap img {
                    max-width: 560px;
                    width: 100%;
                    border-radius: 18px;
                    filter: drop-shadow(0 12px 36px rgba(109,50,236,0.18));
                    transition: transform 0.45s cubic-bezier(.25,.8,.25,1), filter 0.45s ease;
                }
                .hero-mockup-wrap img:hover {
                    transform: perspective(900px) rotateY(-4deg) rotateX(2deg) scale(1.03);
                    filter: drop-shadow(0 18px 48px rgba(109,50,236,0.28));
                }
                .hero-trust-badges {
                    display: flex;
                    gap: 18px;
                    flex-wrap: wrap;
                    margin-top: 18px;
                }
                .hero-trust-badge {
                    font-size: 13px;
                    color: #444;
                    display: flex;
                    align-items: center;
                    gap: 6px;
                }
                .hero-trust-badge::before {
                    content: "✓";
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    background: #6d32ec;
                    color: #fff;
                    font-size: 11px;
                    font-weight: 700;
                    flex-shrink: 0;
                }
                @media (max-width: 992px) {
                    .hero-mockup-wrap {
                        width: 100%;
                        margin-top: 32px;
                    }
                }
                @media (max-width: 576px) {
                    .hero-mockup-wrap img {
                        max-width: 100%;
                    }
                    .hero-trust-badges {
                        gap: 10px;
                    }
                }
            `}</style>
            <Override slot="SectionContent" display="flex" width="1280px"/>
            <Box
                min-width="100px"
                min-height="100px"
                display="flex"
                justify-content="space-between"
                align-items="center"
                lg-flex-direction="column"
                lg-align-items="center"
                flex="0 1 auto"
            >
                <Box
                    min-width="100px"
                    min-height="100px"
                    width="48%"
                    lg-width="100%"
                    lg-padding="0 40px 40px 40px"
                    padding="0px 20px 0px 60px"
                    sm-padding="0 15px 40px 15px"
                >
                    <Text
                        margin="0px 0px 24px 0px"
                        font="normal 800 44px/1.15 --fontFamily-sans"
                        md-font="normal 800 36px/1.2 --fontFamily-sans"
                        sm-font="normal 800 30px/1.2 --fontFamily-sans"
                        color="#ffffff"
                        text-align="left"
                    >
                        Build, Backtest and Automate Your Trading Strategies{" "}
                        <span style={{ color: '#FD6DF9', textShadow: '0 0 15px rgba(253, 109, 249, 0.4)' }}>with Zero Code</span>
                    </Text>
                    <Text
                        margin="0px 0px 32px 0px"
                        font="normal 400 19px/1.6 --fontFamily-sans"
                        md-font="normal 400 17px/1.6 --fontFamily-sans"
                        color="rgba(255, 255, 255, 0.75)"
                        text-align="left"
                    >
                        Free professional tools for TradingView and a Webhook Server for instant execution of signals on Binance, Bybit, and OKX — all in one place.
                    </Text>
                    <Box
                        min-width="10px"
                        min-height="10px"
                        display="flex"
                        flex-direction="column"
                        sm-align-items="stretch"
                    >
                        <Button
                            margin="0px 0px 0px 0px"
                            padding="16px 44px 16px 44px"
                            background="linear-gradient(135deg, #7b2fce 0%, #5a1da8 100%)"
                            border-radius="14px"
                            font="normal 600 20px/1.5 --fontFamily-sans"
                            sm-font="normal 600 17px/1.5 --fontFamily-sans"
                            transition="all 0.3s ease 0s"
                            border-width="0px"
                            hover-transform="translateY(-2px)"
                            box-shadow="0 8px 24px rgba(109, 50, 236, 0.3)"
                            hover-box-shadow="0 14px 36px rgba(109, 50, 236, 0.4)"
                            type="link"
                            href="https://t.me/cdzv_com_support_bot"
                            target="_blank"
                            rel="noopener noreferrer"
                            text-decoration-line="initial"
                            text-align="center"
                            color="#ffffff"
                        >
                            Get Started Free
                        </Button>
                        <div className="hero-trust-badges">
                            <span className="hero-trust-badge">Free to start</span>
                            <span className="hero-trust-badge">Setup in 2 min</span>
                            <span className="hero-trust-badge">No coding skills needed</span>
                        </div>
                    </Box>
                </Box>
                <div className="hero-mockup-wrap">
                    <img src={heroMockupImg} alt="CDZV Toolkit — visual strategy builder for TradingView" loading="eager" />
                </div>
            </Box>
        </Section>
        <Components.CdzvBenefits background="transparent" padding="0 0 0 0">
            <Override slot="box1" background="transparent"/>
            <Override slot="image" background="transparent" border-radius="50px"/>
        </Components.CdzvBenefits>
        <Components.CdzvToolkit/>
        <UdemyBanner />
        <Components.CdzvRebalnacer padding="10px 0 50px 0"/>
        <Components.CdzvSmartGrid padding="10px 0 0 0"/>
        <Components.CdzvStats padding="10px 0 10px 0" display="block"/>
        <Components.CdzvPricing>
            <Override slot="text"/>
        </Components.CdzvPricing>
        {/*<Components.CdzvComparison>*/
        }
        {/*    <Override*/
        }
        {/*        slot="text10"*/
        }
        {/*        lg-font="normal 500 20px/1.65 --fontFamily-sans"*/
        }
        {/*        md-font="normal 500 15px/1.4 --fontFamily-sans"*/
        }
        {/*        sm-font="15px/0.9 --fontFamily-serifGeorgia"*/
        }
        {/*        sm-margin="0px 0px 40px 0px"*/
        }
        {/*    />*/
        }
        {/*    <Override slot="text11" lg-font="normal 500 20px/1.65 --fontFamily-sans"*/
        }
        {/*              md-font="normal 500 15px/1.4 --fontFamily-sans" sm-font="15px/0.9 --fontFamily-serifGeorgia"/>*/
        }
        {/*    <Override*/
        }
        {/*        slot="text2"*/
        }
        {/*        lg-font="normal 500 20px/1.65 --fontFamily-sans"*/
        }
        {/*        md-font="normal 500 15px/1.4 --fontFamily-sans"*/
        }
        {/*        sm-font="15px/0.9 --fontFamily-serifGeorgia"*/
        }
        {/*        sm-text-align="center"*/
        }
        {/*        sm-margin="25px 0px 30px 0px"*/
        }
        {/*    />*/
        }
        {/*    <Override*/
        }
        {/*        slot="text3"*/
        }
        {/*        lg-font="normal 500 20px/1.65 --fontFamily-sans"*/
        }
        {/*        md-font="normal 500 15px/1.4 --fontFamily-sans"*/
        }
        {/*        sm-font="15px/0.9 --fontFamily-serifGeorgia"*/
        }
        {/*        sm-text-align="center"*/
        }
        {/*    />*/
        }
        {/*    <Override slot="text4" lg-font="normal 500 20px/1.65 --fontFamily-sans"*/
        }
        {/*              md-font="normal 500 15px/1.4 --fontFamily-sans" sm-font="15px/0.9 --fontFamily-serifGeorgia"/>*/
        }
        {/*    <Override*/
        }
        {/*        slot="text5"*/
        }
        {/*        lg-font="normal 500 20px/1.65 --fontFamily-sans"*/
        }
        {/*        md-font="normal 500 15px/1.4 --fontFamily-sans"*/
        }
        {/*        sm-font="15px/0.9 --fontFamily-serifGeorgia"*/
        }
        {/*        sm-margin="0px 0px 40px 0px"*/
        }
        {/*    />*/
        }
        {/*    <Override*/
        }
        {/*        slot="text6"*/
        }
        {/*        lg-font="normal 500 20px/1.65 --fontFamily-sans"*/
        }
        {/*        md-font="normal 500 15px/1.4 --fontFamily-sans"*/
        }
        {/*        sm-font="15px/0.9 --fontFamily-serifGeorgia"*/
        }
        {/*        sm-margin="0px 0px 40px 0px"*/
        }
        {/*    />*/
        }
        {/*    <Override*/
        }
        {/*        slot="text7"*/
        }
        {/*        lg-font="normal 500 20px/1.65 --fontFamily-sans"*/
        }
        {/*        md-font="normal 500 15px/1.4 --fontFamily-sans"*/
        }
        {/*        sm-font="15px/0.9 --fontFamily-serifGeorgia"*/
        }
        {/*        sm-margin="0px 0px 40px 0px"*/
        }
        {/*    />*/
        }
        {/*    <Override*/
        }
        {/*        slot="text8"*/
        }
        {/*        lg-font="normal 500 20px/1.65 --fontFamily-sans"*/
        }
        {/*        md-font="normal 500 15px/1.4 --fontFamily-sans"*/
        }
        {/*        sm-font="15px/0.9 --fontFamily-serifGeorgia"*/
        }
        {/*        sm-text-align="center"*/
        }
        {/*    />*/
        }
        {/*    <Override slot="text9" lg-font="normal 500 20px/1.65 --fontFamily-sans"*/
        }
        {/*              md-font="normal 500 15px/1.4 --fontFamily-sans" sm-font="15px/0.9 --fontFamily-serifGeorgia"/>*/
        }
        {/*    <Override slot="box3" sm-align-self="flex-start"/>*/
        }
        {/*    <Override slot="box13" sm-margin="0px 0px 14px 0px" md-margin="0px 0px 15px 0px"/>*/
        }
        {/*    <Override slot="box14" sm-margin="0px 0px 14px 0px" md-margin="0px 0px 15px 0px"/>*/
        }
        {/*    <Override slot="box25" sm-margin="0px 0px 14px 0px" md-margin="0px 0px 15px 0px"/>*/
        }
        {/*    <Override slot="box26" sm-margin="0px 0px 14px 0px" md-margin="0px 0px 15px 0px"/>*/
        }
        {/*</Components.CdzvComparison>*/
        }
        {/*<Components.CdzvUsers background="--color-light" quarkly-title="Reviews">*/}
        {/*    <Override slot="box9"/>*/}
        {/*    <Override slot="box5"/>*/}
        {/*    <Override slot="box1"/>*/}
        {/*    <Override slot="box"/>*/}
        {/*    <Override slot="box21"/>*/}
        {/*</Components.CdzvUsers>*/}
        <Components.CdzvFaq/>
        <Components.CdzvFooter margin="0px 0px 0px 0px" background="transparent" padding="20px 0 40px 0">
            <Override slot="text2" display="none"/>
        </Components.CdzvFooter>
        <Components.QuarklycommunityKitCookieUsed margin="0px 0px 0px 0px" quarkly-title="CookieUsed"/>
        <Components.QuarklycommunityKitBackToTop padding="0px 0px 0px 0px" margin="0px 0px 0px 0px"
                                                 quarkly-title="BackToTop"/>
        <RawHtml>
            <style place={"endOfHead"} rawKey={"665dd05e1d712a0023346c52"}>
                {":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}\n\nhtml {\nscroll-behavior: smooth;\n}\n"}
            </style>
        </RawHtml>
    </Theme>;
});
